import {settings} from '@gravity-ui/date-utils';
import {Lang, configure as configureUikit} from '@gravity-ui/uikit';
import {setConfig as configureCloudComponents} from '@yandex-data-ui/cloud-components';
import {configure as configureCommon} from '@yandex-data-ui/common';
import {configure as configureNavigation} from '@yandex-data-ui/navigation';

const configureLang = (lang: Lang) => {
    configureUikit({lang});
    configureCommon({lang});
    configureNavigation({lang});
    configureCloudComponents({lang});

    settings.loadLocale(lang).then(() => {
        settings.setLocale(lang);
    });
};

export default configureLang;
